import gql from "graphql-tag";

export const SEND_FEEDBACK = gql`
    mutation SendFeedback($feedbackMessage: feedbackMessage!) {
        sendFeedback(
            feedbackMessage: $feedbackMessage
        ) {
            returnCode
            message
        }
    }
`;
